import React from "react";
import { CardContent } from "./ui/card";
import { Button } from "./ui/button";
import { Copy } from "lucide-react";
import { Table, TableBody, TableCell, TableRow } from "./ui/table";
import QuestionIcon from "../assets//images/trading/questionMark.svg";
import InfoIcon from "../assets//images/trading/info.svg";

export default function Deposit({ onDeposit, bank, refCode }) {
  const referenceCode = refCode;

  const bankDetails = [
    { label: "Recipient", value: bank?.recipientName },
    { label: "Bank", value: bank?.bank },
    { label: "Account Number", value: bank?.accountNumber },
    { label: "Branch Code", value: bank?.branch },
    { label: "SWIFT Code", value: bank?.swift },
    { label: "Type", value: bank?.accountType },
    { label: "Reference", value: refCode },
  ].filter(({ label, value }) => {
    if (label === "SWIFT Code") return !!value;
    return true;
  });

  const handleCopy = (text) => {
    navigator.clipboard.writeText(text).catch(() => {});
  };

  return (
    <CardContent className="md:px-6 px-2">
      <h2 className="text-[20px] font-semibold text-[#6D6584] mb-3">
        Make a deposit
      </h2>
      <p className="text-[16px] text-[#6D6584] mb-5 font-normal">
        Add our details as a beneficiary in your online banking to easily fund
        your ZAR wallet. Always use your own bank account when making a transfer
        - cash deposits are not accepted. Your reference number stays the same
        for every deposit.
      </p>

      <div className="mb-3">
        <button
          type="button"
          className="text-[16px] font-semibold text-[#33125F] underline cursor-pointer flex items-center gap-2"
          onClick={() => alert("Explain how this works...")}
        >
          <img src={QuestionIcon} alt="info" className="w-4 h-4" />
          How does this work?
        </button>
      </div>

      <p className="text-[14px] font-normal text-center text-[#6D6584] mb-2">
        Your reference code
      </p>
      <div className="flex items-center gap-3 mb-6 h-[88px] justify-center bg-[#EBE9EF4D] rounded-2xl">
        <div className="font-semibold text-[20px] text-[#33125F]">
          {referenceCode}
        </div>
        <button
          onClick={() => handleCopy(referenceCode)}
          className="inline-flex items-center justify-center w-[48px] h-[48px] rounded-full border border-gray-300 text-gray-600 hover:bg-gray-100"
        >
          <Copy size={16} />
        </button>
      </div>

      <p className="text-[14px] font-semibold text-[#6D6584] mb-3">
        Bank transfer details
      </p>
      <div className="overflow-hidden rounded-lg border border-gray-200 mb-6">
        <Table className="w-full bg-white">
          <TableBody>
            {bankDetails.map(({ label, value }) => (
              <TableRow
                key={label}
                className="flex items-center justify-between h-[56px]"
              >
                <TableCell className="font-normal text-[14px] text-[#423E51] py-3">
                  {label}
                </TableCell>
                <TableCell className="font-semibold text-[14px] text-[#423E51] flex items-center gap-2">
                  {value}
                  {label === "Account Number" && value && (
                    <button
                      onClick={() => handleCopy(value)}
                      className="inline-flex items-center justify-center w-7 h-7 rounded-full border border-gray-300 text-gray-600 hover:bg-gray-100"
                    >
                      <Copy size={16} />
                    </button>
                  )}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>

      <div className="bg-[#EFF1FC] text-center rounded-2xl p-3 text-[14px] font-semibold text-[#6375E6] mb-6 h-[48px] flex items-center justify-center gap-2">
        <img src={InfoIcon} alt="info" className="w-4 h-4" />
        <p>Your ZAR wallet will update in 2-3 days.</p>
      </div>

      <div className="flex justify-center">
        <Button
          onClick={() => {
            if (onDeposit) {
              onDeposit();
            }
          }}
          className={`px-6 py-4 rounded-full font-semibold transition-opacity w-full sm:min-w-[302px] max-w-sm h-[48px] text-sm sm:text-base bg-[linear-gradient(86.72deg,#57249C_-10.66%,#EB3366_113.47%)] text-white hover:opacity-90 mx-auto"
        `}
        >
          I’ve Made The Deposit
        </Button>
      </div>
    </CardContent>
  );
}
